'use client'

import Footer from "@/components/footer";
import Header from "@/components/header";
import GastronomicalExperience from "@/components/gastronomicalExperience";
import Link from "next/link";
import Image from "next/image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronsRight } from '@fortawesome/pro-solid-svg-icons';
import ProgramsSelection from "./components/programsSelection";
import ProgramComparison from "./components/programComparison";
import Instructors from "@/components/instructors";
import Reviews from "@/components/reviews";
import Faq from "./components/faq";
import ProgramContent from "./components/programContent";
import { useRef } from "react"
import SpecialitySelection from "./components/specialitySelection";

export default function ProgramasTecnicos()  {
  const programsRef = useRef<HTMLDivElement>(null);
  const specialtyRef = useRef<HTMLDivElement>(null);

  const handleScroll = (ref: any) => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  }

  return (
    <>
      <Header sectionName={"programas"} />
      <main className="mt-24 md:mt-52">
        <section className="relative mx-auto py-8 px-8 bigscreen-responsive md:px-0 md:mb-8">
          <div className="hidden xl:block absolute xl:-top-16 -right-[100px]">
            <div className="hidden lg:block absolute top-0 right-0 transform -translate-x-0 -translate-y-0 w-[800px] h-[800px] bg-gradient-to-r from-[#FBA919] to-transparent opacity-5 rounded-full filter blur-lg"/>
            <Image src="/images/heroes/programas.png" alt="Chef" width={584} height={702} className="hidden lg:block relative h-[702px] w-[584px] right-20 z-10" />
            <Image src="/images/logos/escudo.svg" width={176} height={176} className="hidden lg:block absolute -left-32 bottom-10 w-44 h-44 z-10" alt="Escudo Amura" unoptimized/>
          </div>
          <div>
            <p className="flex uppercase font-normal text-center justify-center text-2xl text-[#589542] py-4 lg:justify-start md:py-4">Programas Académicos</p>
            <h1 className="text-center justify-center font-thin text-3xl md:text-6xl lg:text-start md:max-w-3xl xl:max-w-lg">Tu viaje como <span className="font-bold">emprendedor gastronómico </span>comienza aquí.</h1>
            <div className="px-4 md:px-44 lg:px-0 lg:py-6">
              <Image src="/images/lines/halfCirclesGreen.svg" width={208} height={24} className="hidden lg:block h-6 w-52" alt="Decoration" unoptimized/>
              <p className="font-thin text-lg text-center mt-8 md:max-w-md lg:text-start">Descubrí los planes de estudios que te llevarán a cumplir tu sueño</p>
            </div>
            <div className="flex flex-col justify-center items-center font-bold text-sm gap-4 py-6 md:py-8 lg:justify-start lg:items-start lg:text-left lg:max-w-lg">
              <button onClick={()=>handleScroll(programsRef)} className="flex items-center w-60 justify-center rounded-full py-3 px-12 shadow-sm bg-white border-2 border-green hover:bg-green/15 md:text-nowrap">
                Programas Técnicos 
                <FontAwesomeIcon icon={faChevronsRight} className="text-[9px] ml-2"/>
              </button>
              <button onClick={()=>handleScroll(specialtyRef)} className="flex items-center w-60 justify-center rounded-full py-3 px-8 shadow-sm bg-white border-2 border-yellow-dark hover:bg-yellow/15 md:text-nowrap">
                Especialidades 
                <FontAwesomeIcon icon={faChevronsRight} className="text-[9px] ml-2"/>
              </button>
            </div>
          </div>
        </section>

        <ProgramsSelection programsRef={programsRef} />
        <ProgramComparison />
        <SpecialitySelection specialtyRef={specialtyRef} />
        <ProgramContent />
        <Instructors />
        <Reviews />
        <Faq />
        <GastronomicalExperience />
      </main>
      <Footer sectionName={""} />
      <span className="hidden after:bg-green-light after:bg-orange-light after:bg-[#F4BEA4] after:bg-white after:bg-orange-dark bg-green/[95%] bg-orange/[95%] bg-yellow/[95%] bg-yellow bg-green-dark/65 bg-[#c03e0d]/45 bg-[#D1202A59]/85 bg-green-dark/55 bg-[#c03e0d] bg-[#F4BEA4] bg-green bg-orange to-orange-dark bg-red bg-gradient-to-r from-green to-green-dark/85 bg-gradient-to-r from-[#FBA919] to-[#F68729] bg-gradient-to-r from-red to-[#CE2341] bg-gradient-to-r from-yellow to-[#FEC93E] text-green text-orange text-red text-yellow text-gray-400 bg-[#AD222A59]"/>
    </>
  );
}
